import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaCalculator,
  FaEnvelope,
  FaCog,
  FaClipboardList,
  FaFilePdf,
  FaArrowRight,
  FaCheckCircle,
  FaChartBar,
  FaUserCog,
  FaTable,
  FaChartLine,
  FaClock,
  FaUsers,
  FaIndustry,
  FaBuilding,
  FaHardHat,
  FaTools,
  FaChevronRight,
  FaChevronLeft,
  FaTimes,
} from "react-icons/fa";
import "./LeseniePage.css";

const LeseniePage = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [currentImageIndex, setCurrentImageIndex] = React.useState(0);

  const galleryImages = [
    "/lesenia/Obrázok0.png",
    "/lesenia/Obrázok1.png",
    "/lesenia/Obrázok2.png",
    "/lesenia/Obrázok3.png",
    "/lesenia/Obrázok4.png",
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const features = [
    {
      icon: FaCalculator,
      title: "Kalkulácie cien lešení",
      description:
        "Presné a rýchle kalkulácie ceny prenájmu lešení podľa rozmeru, doby prenájmu a konfigurácie. Systém automaticky vypočíta celkovú cenu na základe zadaných parametrov.",
    },
    {
      icon: FaClipboardList,
      title: "Správa zákaziek",
      description:
        "Zákazky sa vytvárajú priamo z kalkulácií jedným klikom. Prehľadný zoznam všetkých zákaziek s filtráciou, stavmi a históriou zmien.",
    },
    {
      icon: FaFilePdf,
      title: "Generovanie PDF",
      description:
        "Automatické generovanie profesionálnych PDF dokumentov – ponúk, zákaziek a faktúr – podľa šablón prispôsobených pre vašu firmu.",
    },
    {
      icon: FaEnvelope,
      title: "Maily pre zákazníkov",
      description:
        "Priame odosielanie e-mailov zákazníkom priamo zo systému. Prílohou je vygenerované PDF. Šablóny mailov sú plne konfigurovateľné.",
    },
    {
      icon: FaCog,
      title: "Plná konfigurovateľnosť",
      description:
        "Každý aspekt systému je konfigurovateľný – cenníky, položky lešení, šablóny dokumentov, e-mailové texty, firemné údaje a ďalšie nastavenia.",
    },
    {
      icon: FaUserCog,
      title: "Správa používateľov",
      description:
        "Rôzne úrovne prístupu pre zamestnancov. Administrátor má plný prístup ku konfigurácii, obchodník vytvára kalkulácie a zákazky.",
    },
    {
      icon: FaChartBar,
      title: "Prehľady a reporty",
      description:
        "Prehľadné štatistiky zákaziek, tržieb a využitia lešení. Export dát do PDF a Excel formátov pre ďalšiu analýzu.",
    },
    {
      icon: FaTable,
      title: "Cenníky a položky",
      description:
        "Flexibilná správa cenníkov a katalógu položiek lešení. Možnosť nastavenia rôznych cien pre rôzne typy zákazníkov alebo sezóny.",
    },
  ];

  const benefits = [
    {
      icon: FaChartLine,
      title: "Rýchlosť kalkulácií",
      value: "10x",
      description: "Oproti manuálnemu výpočtu v Exceli",
    },
    {
      icon: FaClock,
      title: "Úspora času",
      value: "60%",
      description: "Pri vytváraní ponúk a zákaziek",
    },
    {
      icon: FaFilePdf,
      title: "Presnosť dokladov",
      value: "99%",
      description: "Eliminovanie chýb pri generovaní PDF",
    },
    {
      icon: FaUsers,
      title: "Spokojnosť klientov",
      value: "95%",
      description: "S profesionálnymi ponukami zo systému",
    },
  ];

  const packages = [
    {
      name: "Lešenia BASIC",
      price: "Na mieru",
      description: "Pre malé firmy a živnostníkov",
      features: [
        "Kalkulácie cien lešení",
        "Správa zákaziek",
        "Generovanie PDF ponúk",
        "Odosielanie e-mailov",
        "Základný cenník",
        "Do 3 používateľov",
      ],
    },
    {
      name: "Lešenia STANDARD",
      price: "Na mieru",
      description: "Komplexné riešenie pre stredné firmy",
      features: [
        "Všetky funkcie BASIC",
        "Pokročilé kalkulácie",
        "Viacero cenníkov",
        "Šablóny dokumentov",
        "Dashboard a reporty",
        "Do 10 používateľov",
        "Prioritná podpora",
      ],
      popular: true,
    },
    {
      name: "Lešenia PREMIUM",
      price: "Na mieru",
      description: "Enterprise riešenie pre veľké spoločnosti",
      features: [
        "Všetky funkcie STANDARD",
        "Custom funkcionalita",
        "API integrácie",
        "Pokročilé reporty a exporty",
        "Neobmedzený počet používateľov",
        "Podpora 24/7",
        "Onsite školenia",
      ],
    },
  ];

  const industries = [
    {
      icon: FaHardHat,
      title: "Prenájom lešení",
      description: "Kompletná správa prenájmu lešení pre stavebné firmy",
    },
    {
      icon: FaBuilding,
      title: "Stavebné spoločnosti",
      description: "Interné kalkulácie a správa zákaziek na stavbách",
    },
    {
      icon: FaIndustry,
      title: "Priemyselné revízie",
      description: "Lešenia pre údržbu a revíziu priemyselných objektov",
    },
    {
      icon: FaTools,
      title: "Fasády a rekonštrukcie",
      description: "Správa zákaziek pre fasádne a rekonštrukčné práce",
    },
  ];

  const openModal = (imageSrc) => {
    const index = galleryImages.indexOf(imageSrc);
    setCurrentImageIndex(index >= 0 ? index : 0);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex(
      (prev) => (prev - 1 + galleryImages.length) % galleryImages.length
    );
  };

  return (
    <div className="lesenie-page">
      {/* Hero Section */}
      <section className="lesenie-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>Lešenia – Kalkulačný systém</h1>
              <h2>Správa zákaziek a kalkulácií prenájmu lešení</h2>
              <p>
                Webový systém navrhnutý pre firmy zaoberajúce sa prenájmom
                lešení. Umožňuje rýchle vytváranie kalkulácií ceny, správu
                zákaziek, automatické generovanie PDF dokumentov a odosielanie
                ponúk zákazníkom e-mailom. Všetko konfigurovateľné podľa
                potrieb klienta.
              </p>
              <div className="hero-actions">
                <Link to="/kontakt" className="btn btn-primary">
                  <FaArrowRight /> Žiadosť o ponuku
                </Link>
              </div>
            </div>
            <div className="hero-image">
              <img
                src="/lesenia/Obrázok0.png"
                alt="Lešenia – Kalkulačný systém"
                className="hero-product-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          <h2>Ukážky systému</h2>
          <div className="gallery-grid">
            {galleryImages.map((img, index) => (
              <div
                key={index}
                className="gallery-item"
                onClick={() => openModal(img)}
              >
                <img src={img} alt={`Lešenia systém – ukážka ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2>Pokročilé funkcie systému</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">
                  <feature.icon />
                </div>
                <h4>{feature.title}</h4>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <h2>Výsledky, ktoré môžete očakávať</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-icon">
                  <benefit.icon />
                </div>
                <div className="benefit-value">{benefit.value}</div>
                <h4>{benefit.title}</h4>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries Section */}
      <section className="industries-section">
        <div className="container">
          <h2>Vhodné pre všetky typy podnikov</h2>
          <div className="industries-grid">
            {industries.map((industry, index) => (
              <div key={index} className="industry-card">
                <div className="industry-icon">
                  <industry.icon />
                </div>
                <h4>{industry.title}</h4>
                <p>{industry.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {isModalOpen && (
        <div className="image-modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              <FaTimes />
            </button>
            <button className="modal-prev" onClick={prevImage}>
              <FaChevronLeft />
            </button>
            <img
              src={galleryImages[currentImageIndex]}
              alt={`Lešenia systém – ukážka ${currentImageIndex + 1}`}
            />
            <button className="modal-next" onClick={nextImage}>
              <FaChevronRight />
            </button>
            <div className="modal-counter">
              {currentImageIndex + 1} / {galleryImages.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LeseniePage;
